import DataObjectMap from 'assets/components/dataObjectMap/DataObjectMap';
import Icon from 'assets/components/icon/Icon';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import ThemeTableSimple2 from 'assets/components/table/themes/Theme.Table.Simple.2';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import ThemeWrapperPaper from 'assets/themes/wrappers/Theme.Wrapper.Paper';
import { CanadaProvinces } from 'models/enums/CanadaProvinces';
import { useProductProvider } from '../../Product.Hooks';

const sectionColumn: React.CSSProperties = { fontWeight: 'bold', textAlign: 'left', color: Theme.Color.primaryAlt };
const sectionRow: React.CSSProperties = { backgroundColor: Theme.Color.primaryLight };
const input: React.CSSProperties = { textAlign: 'right' };

export default function ProductEditTaxes() {
  const { form } = useProductProvider();
  const { lang } = getLocales();
  function updateTax(tax: Partial<Model.IProductTax>) {
    const otherTaxes = form.data.productTaxes?.filter((it) => it.provinceCode !== tax.provinceCode) || [];
    if (!tax.claimsGstHst) tax.claimsGstHst = 0;
    if (!tax.claimsProvincialSalesTax) tax.claimsProvincialSalesTax = 0;
    if (!tax.dealerCostGstHst) tax.dealerCostGstHst = 0;
    if (!tax.dealerCostProvincialSalesTax) tax.dealerCostProvincialSalesTax = 0;
    if (!tax.dealerRemittanceGstHst) tax.dealerRemittanceGstHst = 0;
    if (!tax.dealerRemittanceProvincialSalesTax) tax.dealerRemittanceProvincialSalesTax = 0;
    if (!tax.dealerProfitGstHst) tax.dealerProfitGstHst = 0;
    if (!tax.dealerProfitProvincialSalesTax) tax.dealerProfitProvincialSalesTax = 0;
    form.update({ productTaxes: [...otherTaxes, tax] });
  }

  return (
    <FormWrapper class={ThemeWrapperPaper}>
      <div style={{ fontSize: Theme.FontSize.L, fontWeight: 'bold' }}>{lang.taxes}</div>
      <br />
      <table className={ThemeTableSimple2}>
        <thead>
          <tr>
            <th children={lang.province} />
            <th children={lang.pst} style={{ textAlign: 'right' }} />
            <th children={lang.gstHst} style={{ textAlign: 'right' }} />
          </tr>
        </thead>
        <tbody>
          <tr style={sectionRow}>
            <td colSpan={3} style={sectionColumn} children={lang.dealerCost} />
          </tr>
          <DataObjectMap
            data={CanadaProvinces}
            render={({ data: provinceName, key: provinceCode }) => {
              const tax = form.data.productTaxes?.find((t) => t.provinceCode === provinceCode);
              return (
                <tr key={provinceCode}>
                  <td>
                    {provinceName} ({provinceCode})
                  </td>
                  <td>
                    <NumberInput<'tax'>
                      name="tax"
                      value={Number(((tax?.dealerCostProvincialSalesTax || 0) * 100).toFixed(3))}
                      onChange={(d) =>
                        updateTax({
                          ...tax,
                          dealerCostProvincialSalesTax: d.tax * 0.01,
                          provinceCode,
                        })
                      }
                      step={0.001}
                      icon={<Icon class="fas-percent" />}
                      style={{ input: input }}
                    />
                  </td>
                  <td>
                    <NumberInput<'tax'>
                      name="tax"
                      value={Number(((tax?.dealerCostGstHst || 0) * 100).toFixed(3))}
                      onChange={(d) =>
                        updateTax({
                          ...tax,
                          dealerCostGstHst: d.tax * 0.01,
                          provinceCode,
                        })
                      }
                      step={0.001}
                      icon={<Icon class="fas-percent" />}
                      style={{ input: input }}
                    />
                  </td>
                </tr>
              );
            }}
          />
          <tr style={sectionRow}>
            <td colSpan={3} style={sectionColumn} children={lang.dealerRemittance} />
          </tr>
          <DataObjectMap
            data={CanadaProvinces}
            render={({ data: provinceName, key: provinceCode }) => {
              const tax = form.data.productTaxes?.find((t) => t.provinceCode === provinceCode);
              return (
                <tr key={provinceCode}>
                  <td>
                    {provinceName} ({provinceCode})
                  </td>
                  <td>
                    <NumberInput<'tax'>
                      name="tax"
                      value={Number(((tax?.dealerRemittanceProvincialSalesTax || 0) * 100).toFixed(3))}
                      onChange={(d) =>
                        updateTax({
                          ...tax,
                          dealerRemittanceProvincialSalesTax: d.tax * 0.01,
                          provinceCode,
                        })
                      }
                      step={0.001}
                      icon={<Icon class="fas-percent" />}
                      style={{ input: input }}
                    />
                  </td>
                  <td>
                    <NumberInput<'tax'>
                      name="tax"
                      value={Number(((tax?.dealerRemittanceGstHst || 0) * 100).toFixed(3))}
                      onChange={(d) =>
                        updateTax({
                          ...tax,
                          dealerRemittanceGstHst: d.tax * 0.01,
                          provinceCode,
                        })
                      }
                      step={0.001}
                      icon={<Icon class="fas-percent" />}
                      style={{ input: input }}
                    />
                  </td>
                </tr>
              );
            }}
          />
          <tr style={sectionRow}>
            <td colSpan={3} style={sectionColumn} children={lang.dealerProfit} />
          </tr>
          <DataObjectMap
            data={CanadaProvinces}
            render={({ data: provinceName, key: provinceCode }) => {
              const tax = form.data.productTaxes?.find((t) => t.provinceCode === provinceCode);
              return (
                <tr key={provinceCode}>
                  <td>
                    {provinceName} ({provinceCode})
                  </td>
                  <td>
                    <NumberInput<'tax'>
                      name="tax"
                      value={Number(((tax?.dealerProfitProvincialSalesTax || 0) * 100).toFixed(3))}
                      onChange={(d) =>
                        updateTax({
                          ...tax,
                          dealerProfitProvincialSalesTax: d.tax * 0.01,
                          provinceCode,
                        })
                      }
                      step={0.001}
                      icon={<Icon class="fas-percent" />}
                      style={{ input: input }}
                    />
                  </td>
                  <td>
                    <NumberInput<'tax'>
                      name="tax"
                      value={Number(((tax?.dealerProfitGstHst || 0) * 100).toFixed(3))}
                      onChange={(d) =>
                        updateTax({
                          ...tax,
                          dealerProfitGstHst: d.tax * 0.01,
                          provinceCode,
                        })
                      }
                      step={0.001}
                      icon={<Icon class="fas-percent" />}
                      style={{ input: input }}
                    />
                  </td>
                </tr>
              );
            }}
          />
          <tr style={sectionRow}>
            <td colSpan={3} style={sectionColumn} children={lang.claim} />
          </tr>
          <DataObjectMap
            data={CanadaProvinces}
            render={({ data: provinceName, key: provinceCode }) => {
              const tax = form.data.productTaxes?.find((t) => t.provinceCode === provinceCode);
              return (
                <tr key={provinceCode}>
                  <td>
                    {provinceName} ({provinceCode})
                  </td>
                  <td>
                    <NumberInput<'tax'>
                      name="tax"
                      value={Number(((tax?.claimsProvincialSalesTax || 0) * 100).toFixed(3))}
                      onChange={(d) =>
                        updateTax({
                          ...tax,
                          claimsProvincialSalesTax: d.tax * 0.01,
                          provinceCode,
                        })
                      }
                      step={0.001}
                      icon={<Icon class="fas-percent" />}
                      style={{ input: input }}
                    />
                  </td>
                  <td>
                    <NumberInput<'tax'>
                      name="tax"
                      value={Number(((tax?.claimsGstHst || 0) * 100).toFixed(3))}
                      onChange={(d) =>
                        updateTax({
                          ...tax,
                          claimsGstHst: d.tax * 0.01,
                          provinceCode,
                        })
                      }
                      step={0.001}
                      icon={<Icon class="fas-percent" />}
                      style={{ input: input }}
                    />
                  </td>
                </tr>
              );
            }}
          />
        </tbody>
      </table>
    </FormWrapper>
  );
}
